import React from "react";

function WeightIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g fill="currentColor" fillRule="nonzero">
          <path d="M23.92 20.9L20.495 7.206C20.318 6.494 19.726 6 19.05 6h-4.066a3.718 3.718 0 00.767-2.25 3.75 3.75 0 00-7.5 0c0 .848.292 1.622.767 2.25H4.95c-.676 0-1.27.494-1.447 1.206L.08 20.9C-.31 22.46.768 24 2.25 24H21.75c1.483 0 2.56-1.539 2.17-3.1zM9.75 3.75c0-1.24 1.01-2.25 2.25-2.25s2.25 1.01 2.25 2.25S13.24 6 12 6 9.75 4.99 9.75 3.75zm12.528 18.465c-.101.13-.275.285-.53.285H2.252c-.254 0-.428-.155-.53-.285a1.113 1.113 0 01-.185-.952L4.96 7.57c.01-.04.025-.062.02-.07h14.03c.01.013.023.034.032.07l3.423 13.693c.085.339.015.695-.186.952z"></path>
        </g>
      </g>
    </svg>
  );
}

export default WeightIcon;
